import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=1a883059&scoped=true"
import script from "./EditPage.vue?vue&type=script&lang=js"
export * from "./EditPage.vue?vue&type=script&lang=js"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=1a883059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a883059",
  null
  
)

export default component.exports